import { render, staticRenderFns } from "./InputContent.vue?vue&type=template&id=a89214da&scoped=true&"
import script from "./InputContent.vue?vue&type=script&lang=js&"
export * from "./InputContent.vue?vue&type=script&lang=js&"
import style0 from "./InputContent.vue?vue&type=style&index=0&id=a89214da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89214da",
  null
  
)

export default component.exports